import { KazooError } from "@kazoohr/types";

/**
 * Takes a message, metadata, an error type (i.e. KazooError, UserInputError, Error, etc.).
 * Returns a function that throws the specified error (or KazooError if unspecified) with
 * the data passed into the function. This is useful as a generic error handler.
 *
 * Note: the function that this function returns throws.
 */
export function makeErrorHandler({
  message,
  metadata,
  error = KazooError,
}: {
  message: string;
  metadata: Record<string, unknown>;
  /**
   *  Represents any error class (remember, uninstantiated classes in JS are functions,
   *  so this looks like a function signature, because it is).
   */
  error?: new (...args: any[]) => unknown;
}) {
  return (...args: unknown[]) => {
    throw new error(message, {
      ...metadata,
      ...args,
    });
  };
}
